import React from "react";

export default function EditorSidebar({
  step,
  pageUrl,
  setPageUrl,
  onReload,
  readOnly,
  content,
  setContent,
  textColor,
  setTextColor,
  bgColor,
  setBgColor,
  onSaveVariation,
  isSavingVariation,
  variationCount,
  onProceedToGoal,
  goalSelector,
  onSaveGoal,
  previewMode,
  onPreviewModeChange,
  compact = false,
}) {
  if (compact) {
    return (
      <div
        className={`sidebar sidebar-compact sidebar-toolbar ${
          step === 3 ? "sidebar-toolbar-preview-only" : ""
        }`}
      >
        {step < 3 && (
          <div className="toolbar-group toolbar-group-url">
            <label>URL</label>
            <input value={pageUrl} onChange={(e) => setPageUrl(e.target.value)} disabled={readOnly} />
            <button className="block-btn" onClick={onReload}>
              Reload
            </button>
          </div>
        )}

        {step === 1 && (
          <>
            <div className="toolbar-group toolbar-group-content">
              <label>Text</label>
              <input
                value={content}
                onChange={(e) => setContent(e.target.value)}
                disabled={readOnly}
                placeholder="Selected text"
              />
            </div>

            <div className="toolbar-group toolbar-group-colors">
              <div className="color-field">
                <label>Text</label>
                <input
                  type="color"
                  value={textColor}
                  onChange={(e) => setTextColor(e.target.value)}
                  disabled={readOnly}
                />
              </div>
              <div className="color-field">
                <label>Bg</label>
                <input
                  type="color"
                  value={bgColor}
                  onChange={(e) => setBgColor(e.target.value)}
                  disabled={readOnly}
                />
              </div>
            </div>

            {!readOnly && (
              <div className="toolbar-group toolbar-group-actions">
                <button className="save green block-btn" onClick={onSaveVariation} disabled={isSavingVariation}>
                  {isSavingVariation ? "Saving..." : "Save"}
                </button>
                <button
                  className="save green block-btn subtle-top-gap"
                  onClick={onProceedToGoal}
                  disabled={variationCount === 0}
                >
                  Goal
                </button>
              </div>
            )}

            {readOnly && <div className="readonly-note">Read-only</div>}
          </>
        )}

        {step === 2 && (
          <>
            <div className="toolbar-group toolbar-group-content">
              <label>Goal</label>
              <input value={goalSelector} readOnly />
            </div>
            {!readOnly && (
              <div className="toolbar-group toolbar-group-actions">
                <button className="save green block-btn" onClick={onSaveGoal}>
                  Complete
                </button>
              </div>
            )}
            {readOnly && <div className="readonly-note">Read-only</div>}
          </>
        )}

        {step === 3 && (
          <div className="toolbar-group toolbar-group-preview-actions">
            <button
              type="button"
              className={`block-btn preview-toggle-btn ${
                previewMode === "variation" ? "preview-toggle-btn-active" : ""
              }`}
              onClick={() => onPreviewModeChange?.("variation")}
            >
              Variation
            </button>
            <button
              type="button"
              className={`block-btn preview-toggle-btn ${
                previewMode === "default" ? "preview-toggle-btn-active" : ""
              }`}
              onClick={() => onPreviewModeChange?.("default")}
            >
              Default
            </button>
          </div>
        )}
      </div>
    );
  }

  if (step >= 3) return null;

  return (
    <div className={`sidebar ${compact ? "sidebar-compact" : ""}`}>
      <div className={`panel ${compact ? "panel-compact panel-inline" : ""}`}>
        <label>Page URL</label>
        <input value={pageUrl} onChange={(e) => setPageUrl(e.target.value)} disabled={readOnly} />
        <button className="block-btn" onClick={onReload}>
          Reload
        </button>
      </div>

      {step === 1 && (
        <div className={`panel panel-gap ${compact ? "panel-compact panel-inline" : ""}`}>
          <label>Text Content</label>
          <input value={content} onChange={(e) => setContent(e.target.value)} disabled={readOnly} />
          <div className="color-pair">
            <div className="color-field">
              <label>Text Color</label>
              <input
                type="color"
                value={textColor}
                onChange={(e) => setTextColor(e.target.value)}
                disabled={readOnly}
              />
            </div>
            <div className="color-field">
              <label>Background Color</label>
              <input
                type="color"
                value={bgColor}
                onChange={(e) => setBgColor(e.target.value)}
                disabled={readOnly}
              />
            </div>
          </div>
          {!readOnly && (
            <>
              <button
                className="save green block-btn"
                onClick={onSaveVariation}
                disabled={isSavingVariation}
              >
                {isSavingVariation ? "Saving..." : "Save Variation"}
              </button>
              <button
                className="save green block-btn subtle-top-gap"
                onClick={onProceedToGoal}
                disabled={variationCount === 0}
              >
                Proceed To Goal Setup
              </button>
            </>
          )}
          {readOnly && <div className="readonly-note">Setup completed. Step 1 is read-only.</div>}
        </div>
      )}

      {step === 2 && (
        <div className={`panel panel-gap ${compact ? "panel-compact panel-inline" : ""}`}>
          <label>Goal Selector</label>
          <input value={goalSelector} readOnly />
          {!readOnly && (
            <button className="save green block-btn" onClick={onSaveGoal}>
              Complete Setup
            </button>
          )}
          {readOnly && <div className="readonly-note">Setup completed. Step 2 is read-only.</div>}
        </div>
      )}
    </div>
  );
}
